<template>
    <div class="content-container w-full px-1 lg:px-7 xl:px-10 py-9 rounded-md">
        <div
            class="w-full h-full scrollbar px-3"
            style="height:calc(100% - 10px)"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "ContentContainer",

    components: {},
    setup() {},
});
</script>
<style lang="scss">
.content-container {
    height: calc(100vh - 260px);
    @screen md {
        height: calc(100vh - 200px);
    }
    &.content-container-big {
        height: calc(100vh - 200px);
        @screen md {
            height: calc(100vh - 140px);
        }
        @apply pt-0 pb-8;
    }
}
</style>
